export { default as FontSizeControl } from './font-size-control';
export { default as useFontSizeControl } from './use-font-size-control';
//# sourceMappingURL=index.js.map